export const ALL = "ALL";
export const ALL_RESULTS = "ALL_RESULTS";
export const AND = "AND";
export const BLOG = "BLOG";
export const CLEAR = "CLEAR";
export const CLEAR_FILTERS = "CLEAR_FILTERS";
export const CLOSE = "CLOSE";
export const COLLAPSE = "COLLAPSE";
export const COOKIE_ACCEPT = "COOKIE_ACCEPT";
export const COOKIE_ADVERTISING_MESSAGE = "COOKIE_ADVERTISING_MESSAGE";
export const COOKIE_ANALYTICS_MESSAGE = "COOKIE_ANALYTICS_MESSAGE";
export const COOKIE_BAR_MESSAGE = "COOKIE_BAR_MESSAGE";
export const COOKIE_FUNCTIONAL_MESSAGE = "COOKIE_FUNCTIONAL_MESSAGE";
export const COOKIE_SUBMIT = "COOKIE_SUBMIT";
export const COOKIE_UPDATE = "COOKIE_UPDATE";
export const COOKIE_VIDEO_MESSAGE = "COOKIE_VIDEO_MESSAGE";
export const DATE_AND_TIME = "DATE_AND_TIME";
export const DISCIPLINES = "DISCIPLINES";
export const DURATION = "DURATION";
export const EMAIL = "EMAIL";
export const EVENT = "EVENT";
export const EVENTS = "EVENTS";
export const EXPAND = "EXPAND";
export const LOCATION = "LOCATION";
export const MENU_ARIA_LABEL = "MENU_ARIA_LABEL";
export const NEWS = "NEWS";
export const NEWSLETTER_PRIVACY_STATEMENT = "NEWSLETTER_PRIVACY_STATEMENT";
export const NEWSLETTER_SUBTEXT = "NEWSLETTER_SUBTEXT";
export const NEWSLETTER_TITLE = "NEWSLETTER_TITLE";
export const NO_CONTENT_FALLBACK_BODY = "NO_CONTENT_FALLBACK_BODY";
export const NO_CONTENT_FALLBACK_TITLE = "NO_CONTENT_FALLBACK_TITLE";
export const NO_PROJECTS_FOUND = "NO_PROJECTS_FOUND";
export const OPTIONAL = "OPTIONEEL";
export const OVERVIEW = "OVERVIEW";
export const PARTNERS = "PARTNERS";
export const PERSON = "PERSON";
export const PLAY_VIDEO = "PLAY_VIDEO";
export const PR = "PR";
export const PRICIPAL_INVESTIGATOR = "PRICIPAL_INVESTIGATOR";
export const PROJECT = "PROJECT";
export const PROJECT_INFO = "PROJECT_INFO";
export const PROJECT_PUBLICATIONS = "PROJECT_PUBLICATIONS";
export const PROJECT_RESEARCHERS = "PROJECT_RESEARCHERS";
export const RELATED = "RELATED";
export const RELATED_EVENTS = "RELATED_EVENTS";
export const RELATED_PROJECTS = "RELATED_PROJECTS";
export const REQUIRED = "REQUIRED";
export const RESEARCH_DOMAINS = "RESEARCH_DOMAINS";
export const RESEARCH_ACTIVITIES = "RESEARCH_ACTIVITIES";
export const RESOURCE_TYPES = "RESOURCE_TYPES";
export const SEARCH_ARIA_LABEL = "SEARCH_ARIA_LABEL";
export const SEARCH_PLACEHOLDER = "SEARCH_PLACEHOLDER";
export const SEARCH_RESULT_FOUND_FOR = "SEARCH_RESULT_FOUND_FOR";
export const SEARCH_RESULTS_FOUND_FOR = "SEARCH_RESULTS_FOUND_FOR";
export const SEARCH_TITLE = "SEARCH_TITLE";
export const SHOW_ALL = "SHOW_ALL";
export const SHOW_LESS = "SHOW_LESS";
export const SHOW_MORE = "SHOW_MORE";
export const SKIPLINK_CONTENT = "SKIPLINK_CONTENT";
export const SKIPLINK_NAV = "SKIPLINK_NAV";
export const SKIPLINK_SEARCH = "SKIPLINK_SEARCH";
export const SPECIALISM = "SPECIALISM";
export const SUBSCRIBE = "SUBSCRIBE";
export const SWITCH_LOCALE = "SWITCH_LOCALE";
export const USED_RESOURCES = "USED_RESOURCES";
export const WEBSITE = "WEBSITE";
export const YOUR_EMAIL_ADDRESS = "YOUR_EMAIL_ADDRESS";

export const translate = (type, locale = "en") => {
  const texts = {
    [NEWSLETTER_TITLE]: {
      nl: "Blijf op de hoogte via onze Nieuwsbrief",
      en: "Stay up to date with our Newsletter",
    },
    [NEWSLETTER_SUBTEXT]: {
      nl: "Door je aan te melden voor de nieuwsbrief ga je akkoord met onze",
      en: "By subscribing to our newsletter you agree to our",
    },
    [NEWSLETTER_PRIVACY_STATEMENT]: {
      nl: "privacyverklaring",
      en: "privacy statement",
    },
    [SHOW_MORE]: {
      nl: "Toon meer",
      en: "Show more",
    },
    [SHOW_LESS]: {
      nl: "Toon minder",
      en: "Show less",
    },
    [YOUR_EMAIL_ADDRESS]: {
      nl: "Jouw e-mailadres",
      en: "Your emailadress",
    },
    [SUBSCRIBE]: {
      nl: "Aanmelden",
      en: "Subscribe",
    },
    [REQUIRED]: {
      nl: "Dit veld is verplicht.",
      en: "This field is required.",
    },
    [ALL]: {
      nl: "Alle",
      en: "All",
    },
    [ALL_RESULTS]: {
      nl: "Alle resultaten",
      en: "All results",
    },
    COOKIE_ADVERTISING_MESSAGE: {
      nl: "Social Media: cookies die ervoor zorgen dat bezoekers content van social medianetwerken als YouTube kunnen bekijken op deze website. Deze social medianetwerken kunnen bezoekers mogelijk volgen en hun internetgedrag monitoren voor eigen doeleinden.",
      en: "Social Media: cookies that enable visitors to view content from social media networks such as YouTube on this website. These social media networks may be able to track visitors and monitor their internet behavior for their own purposes.",
    },
    COOKIE_ANALYTICS_MESSAGE: {
      nl: "Analytics: cookies waarmee we het gebruik van de site kunnen meten. Deze gegevens worden anoniem verzameld voor statistische analyse.",
      en: "Analytics: cookies with which we can measure the use of the site. This data is collected anonymously for statistical analysis.",
    },
    COOKIE_FUNCTIONAL_MESSAGE: {
      nl: "Functioneel: cookies die ervoor zorgen dat de site naar behoren werkt.",
      en: "Functional: cookies that ensure that the site works properly.",
    },
    [COOKIE_ACCEPT]: {
      nl: "Akkoord",
      en: "Accept",
    },
    [COOKIE_BAR_MESSAGE]: {
      nl: "Clariah maakt gebruik van cookies voor zover deze noodzakelijk zijn voor een goede werking van de website en om de kwaliteit of effectiviteit van de website te verbeteren.",
      en: "Clariah uses cookies insofar as they are necessary for the proper functioning of the website and to improve the quality or effectiveness of the website.",
    },
    [COOKIE_UPDATE]: {
      nl: "Cookies aanpassen",
      en: "Update cookies",
    },
    [COOKIE_VIDEO_MESSAGE]: {
      nl: "Om videos te bekijken moet je de advertising cookies accepteren.",
      en: "You need to update your cookies to watch videos.",
    },
    [COOKIE_SUBMIT]: {
      nl: "Opslaan",
      en: "Save",
    },
    [RELATED]: {
      nl: "Gerelateerd",
      en: "Related",
    },
    [RELATED_PROJECTS]: {
      nl: "Meer projecten",
      en: "More projects",
    },
    [RELATED_EVENTS]: {
      nl: "Meer evenementen",
      en: "More events",
    },
    [PROJECT_INFO]: {
      nl: "Project info",
      en: "Project info",
    },
    [PROJECT_RESEARCHERS]: {
      nl: "Onderzoekers",
      en: "Researchers",
    },
    [PROJECT_PUBLICATIONS]: {
      nl: "Publicaties",
      en: "Publications",
    },
    [PROJECT]: {
      nl: "Project",
      en: "Project",
    },
    [EVENT]: {
      nl: "Evenement",
      en: "Event",
    },
    [EVENTS]: {
      nl: "Evenementen",
      en: "Events",
    },
    [NEWS]: {
      nl: "Nieuws",
      en: "News",
    },
    [OPTIONAL]: {
      nl: "Optioneel",
      en: "Optional",
    },
    [PRICIPAL_INVESTIGATOR]: {
      nl: "Hoofdonderzoeker",
      en: "Principal investigator",
    },
    [DURATION]: {
      nl: "Duur",
      en: "Duration",
    },
    [DISCIPLINES]: {
      nl: "Disciplines",
      en: "Disciplines",
    },
    [RESOURCE_TYPES]: {
      nl: "Resource types",
      en: "Resource types",
    },
    [RESEARCH_ACTIVITIES]: {
      nl: "Research activities",
      en: "Research activities",
    },
    [RESEARCH_DOMAINS]: {
      nl: "Research domains",
      en: "Research domains",
    },
    [PARTNERS]: {
      nl: "Partners",
      en: "Partners",
    },
    [PR]: {
      nl: "PI",
      en: "PI",
    },
    [USED_RESOURCES]: {
      nl: "Gebruikte resources",
      en: "Used Resources",
    },
    [EMAIL]: {
      nl: "E-mail",
      en: "Email",
    },
    [SPECIALISM]: {
      nl: "Specialisatie",
      en: "Specialism",
    },
    [WEBSITE]: {
      nl: "Website",
      en: "Website",
    },
    [PERSON]: {
      nl: "Wie is wie",
      en: "Who is who",
    },
    [DATE_AND_TIME]: {
      nl: "Datum en tijd",
      en: "Date and time",
    },
    [LOCATION]: {
      nl: "Locatie",
      en: "Location",
    },
    [OVERVIEW]: {
      nl: "Overzicht",
      en: "Overview",
    },
    [SEARCH_PLACEHOLDER]: {
      nl: "Waar ben je naar op zoek?",
      en: "What are you looking for?",
    },
    [SEARCH_ARIA_LABEL]: {
      nl: "Zoekbalk openen",
      en: "Open searchbar",
    },
    [MENU_ARIA_LABEL]: {
      nl: "Menu openen",
      en: "Open menu",
    },
    [CLEAR]: {
      nl: "Wissen",
      en: "Reset",
    },
    [BLOG]: {
      nl: "Blog",
      en: "Blog",
    },
    [SHOW_ALL]: {
      nl: "Toon alle",
      en: "Show all",
    },
    [SEARCH_RESULT_FOUND_FOR]: {
      nl: "resultaat gevonden voor",
      en: "result found for",
    },
    [SEARCH_RESULTS_FOUND_FOR]: {
      nl: "resultaten gevonden voor",
      en: "results found for",
    },
    [SEARCH_TITLE]: {
      nl: "Zoekresultaten",
      en: "Search results",
    },
    [PLAY_VIDEO]: {
      nl: "Video afspelen",
      en: "Play video",
    },
    [EXPAND]: {
      nl: "Uitklappen",
      en: "Expand",
    },
    [COLLAPSE]: {
      nl: "Inklappen",
      en: "Collapse",
    },
    [CLOSE]: {
      nl: "Sluiten",
      en: "Close",
    },
    [SKIPLINK_CONTENT]: {
      nl: "Direct naar inhoud",
      en: "Jump to content",
    },
    [SKIPLINK_NAV]: {
      nl: "Direct naar hoofdnavigatie",
      en: " Main navigation",
    },
    [SKIPLINK_SEARCH]: {
      nl: "Direct zoeken",
      en: "Jump to search",
    },
    [SWITCH_LOCALE]: {
      nl: "This page in english",
      en: "Deze pagina in het nederlands",
    },
    [NO_PROJECTS_FOUND]: {
      nl: "Er zijn geen projecten gevonden.",
      en: "No projects found.",
    },
    [CLEAR_FILTERS]: {
      nl: "Alle filters wissen",
      en: "Clear all filters",
    },
    [NO_CONTENT_FALLBACK_TITLE]: {
      nl: "Niet beschikbaar",
      en: "Not available",
    },
    [NO_CONTENT_FALLBACK_BODY]: {
      nl: "Deze content is (nog) niet beschikbaar.",
      en: "This content is not (yet) available.",
    },
  };

  type = type.replace("CLARIAH.", "").replace("INEO.", "");

  if (!texts[type] || !texts[type][locale]) {
    // console.warn(`Missing translated text for ${type}/${locale}`);
    return null;
  }

  return texts[type][locale];
};
